<template>
  <div class="header">
    <div class="logo">
      <img src="../../assets/login/login_logo_blue.png" alt="" />
    </div>
    <div class="navbar">
      <div class="langStyle">
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            {{ languageMap[language]
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(language, key) in languageMap"
              :key="key"
              :command="key"
              >{{ language }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="protocol-btn" @click="backLogin">{{ $t("button.login") }}</div>
  </div>
</template>

<script>
export default {
  props: ["lang","loginType"],
  data() {
    return {
      language:
        this.$i18n.locale == "en" || this.$i18n.locale == "zh-CN"
          ? this.$i18n.locale
          : "en",
      languageMap: {
        en: "English",
        "zh-CN": "简体中文",
      },
      langHistory: null
    };
  },
  watch: {
    language: function (newValue) {
      this.$emit("child-event", newValue);
    },
  },
  created() {
    this.langHistory = this.$i18n.locale;
    this.$i18n.locale =
      this.langHistory == "en" || this.langHistory == "zh-CN"
        ? this.$i18n.locale
        : "en";
  },
  methods: {
    backLogin() {
      this.$router.push({
        name: "Login",
        params:{
          loginType:this.loginType
        }
      });
      // this.$i18n.locale = this.langHistory;
    },
    handleCommand(command) {
      this.language = command;
      this.$i18n.locale = command;
      this.$actions.setGlobalState({
        currentLanguage: command,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  height: 60px;
  line-height: 60px;
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(210, 212, 213, 0.8);
  display: flex;
  .logo {
    width: 300px;
    overflow: auto;
    padding: 0 20px;
    img {
      height: 30px;
      vertical-align: middle;
    }
  }
  .navbar {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    padding: 0 20px;
    box-sizing: border-box;
    .langStyle {
      padding: 0 20px;
    }
    .el-dropdown-link {
      color: #6782a4;
      font-size: 14px;
      cursor: pointer;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }
    .el-icon-arrow-down:before {
      content: "\e790";
    }
  }
  .protocol-btn {
    color: #015ac5;
    font-size: 14px;
    margin-right: 50px;
    cursor: pointer;
  }
}
</style>
